import { render } from "./PersonalPage.vue?vue&type=template&id=108c29a1"
import script from "./PersonalPage.vue?vue&type=script&lang=js"
export * from "./PersonalPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__